import { get } from 'vuex-pathify';
export default {
  computed: {
    antennaSignalDeterminationModuleVerboseName: get(
      'admin/additionalModules@ANTENNA_SIGNAL_BEARING_MODULE.verbose_name'
    ),
    isAntennaSignalDeterminationModuleEnabled: get('admin/additionalModules@ANTENNA_SIGNAL_BEARING_MODULE.enabled'),
    isAntennaSignalDeterminationSettingEnabled: get('admin/settingsValues@antenna_signal_bearing_enabled'),
    hasAntennaSignalDeterminationPermissions() {
      return this.$store.get('users/toolsPermissions')['ANTENNA_SIGNAL_BEARING_MODULE'].main_value > 0;
    },
    isAntennaSignalDeterminationToolVisible() {
      return (
        this.isAntennaSignalDeterminationModuleEnabled &&
        this.isAntennaSignalDeterminationSettingEnabled &&
        this.hasAntennaSignalDeterminationPermissions &&
        this.isCurrentLayerPointGeometry &&
        this.currentLayerScope === 'core'
      );
    },
    antennaSignalDeterminationTool() {
      return this.isAntennaSignalDeterminationToolVisible
        ? [
            {
              name: 'antennaSignalDetermination',
              icon: 'mdi-radio-tower',
              tooltip: this.isOneFeatureSelected
                ? this.antennaSignalDeterminationModuleVerboseName
                : this.$i18n.t('button.toUseTool', {
                    suffix: this.$i18n.t('button.justOneObject'),
                  }),
              fontSize: '19px',
              disabled: !this.isOneFeatureSelected,
            },
          ]
        : [];
    },
  },
  methods: {
    antennaSignalDeterminationAction() {
      this.$router.push({ name: 'antennaSignalDetermination', params: { lid: this.layerId } });
    },
  },
};
